// Global Values
var productPrice, comparePrice, salePriceSum, valueMultiplier,
    bundleLoop = bundleCalc(), bundleLoopValue, unformattedPPD, PPD,
    initBuyBox = false, newVal;

// Will determine the ppd of the bundle product pages
function determinePPD() {  
  let product_ppd = $(".product-per-day-price"),
      total_price,
      valueMultiplier,
      ppd;

  // If a bundle product page, then calculate price-per-day and then return it.
    total_price = $(".product-single__price").text().replace(/[^0-9\.-]+/g,"");
    valueMultiplier = $(".bundle-product-form .js-qty__adjust--plus").siblings('input').val();
    ppd = (total_price / (60 * valueMultiplier));
      
    // Set the ppd attribute to the price of the products.
    product_ppd.attr("ppd", "$"+ppd.toFixed(2));
    
    return ppd; // Return normal product bundle version of ppd.

  $('.dynamic-savings-total').addClass('text--black');
}


// Grab the number of items in the bundle pages
function bundleCalc() {
  let products = $('.bundle-price__product'),
      numOfItems = 0;

  products.each(function() {
    numOfItems = numOfItems + ($(this).data("quantity"));
  });

  return numOfItems;
}

// Will grab the buy box values and generate the compare and product prices
function updatePrices() {
  productPrice = $('.price-container #ProductPrice2').attr('content');
  comparePrice = $('.price-container #ComparePrice').attr('content');
  valueMultiplier = $('.js-qty #Quantity').val();

  salePriceSum = 0;
  bundleLoop = bundleCalc();
  bundleLoopValue = bundleLoop * valueMultiplier;
  unformattedPPD = $('.product-per-day-price').attr('ppd');
  //PPD = Number(unformattedPPD.replace(/[^0-9.-]+/g,""));
  
  productPrice = Number(productPrice.replace(/[^0-9\.-]+/g,""));
  comparePrice = Number(comparePrice.replace(/[^0-9\.-]+/g,""));
  
  // Will determine if the product is a single sale product
  $('.bundle-price__product').each(function(){
    salePriceSum += (parseFloat(($(this).attr('data-original-price'))));
  });
  
  prod_vars = $("#ProductPrice2").text();
  prod_price = prod_vars;

  // If the buy box is initialized, then apply the value multiplier to the compare and sales pricesf
  if(initBuyBox === true) {
    comparePrice = comparePrice * valueMultiplier;
    productPrice = productPrice * valueMultiplier;
    salePriceSum = salePriceSum * valueMultiplier;
  }

  // Will determine if the sale price has a lower number at it's third decimal place.
  if(salePriceSum) {
    let sps = salePriceSum,
        sps_arr = sps.toFixed(3).toString("").split(""),
        sps_last_decimal = parseInt(sps_arr[sps_arr.length - 1]);
    
    if( sps_last_decimal <= 5 ) {
      $('#ProductPrice2').text('$' + (Math.floor(salePriceSum * 100) / 100));
    } else {
      $('#ProductPrice2').text('$' + ((Math.round((salePriceSum + Number.EPSILON) * 100) / 100).toFixed(2)));
    }
  }
  
  $('#ComparePrice').text(`$${(Number((productPrice)) + (5.03)).toFixed(2)}`);
    
  $('.product-per-day-price').text(`THAT'S ONLY \n $${(determinePPD().toFixed(2))} PER DAY`);
}

// Bug fixes on the bundle pages
function bundleBugFixes() {
  $(document).ready(()=>{
    // Removes "aria-hidden" from all the product images on the magnesium bungle page.
    $(".showcase .slick-slide").removeAttr("aria-hidden");

    // Adds the color black the dynamic savings.
    $('.dynamic-savings-total').addClass('text--black');
  })
}
function bundleBuyBoxListeners() {
  if ($('#buy-now').length) {
    // Handle quantity changes and price updates on bundle page
    $(document).ready(function(){
      $(".bundle-product-form .js-qty__num").on('input',(e) => { $(this).attr('value',$(this).val()); });
      $(".bundle-product-form .js-qty__adjust--plus").on('click', () => { currentVal = parseInt($(this).siblings('input').attr('value')); if (!isNaN(currentVal)) { $(this).siblings('input').attr('value',currentVal + 1); }});
      $(".bundle-product-form .js-qty__adjust--minus").on('click',() => { currentVal = parseInt($(this).siblings('input').attr('value')); newVal = currentVal - 1; if(newVal < 1) { newVal = 1;} if (!isNaN(currentVal)) { $(this).siblings('input').attr('value',newVal);}});
      $(".bundle-product-form").on('click', ".js-qty__adjust", () => { updatePrices(); });
      $(".bundle-product-form").change(() => { updatePrices(); });
      $(".bundle-product-form").on('propertychange input', ".js-qty__num", () => { updatePrices(); });
    });
  }

    $(function(){
    //IF SOMEONE CLICKS THE BUTTON WITH THE AFFORMENTIONED CLASS
    $('.bundle--add-to-cart').click(function(e){
      e.preventDefault();
  
      // Form selector
      var $formSelector = $('.bundle-product-form');
  
      // Product ID & Qty array
      var bundleProductIds = [];
      var bundleProductQty = [];
      $('.bundle-price__product').each(function(){
        bundleProductIds.push( $(this).attr('data-variant-id'));
        bundleProductQty.push( $(this).attr('data-quantity'));
      });
  
      //  Quantity Settings
      var bundleQuantitySelector = $('.bundle-product-form .js-qty__num').val();
  
      // create an array of selected products
      var dataToPass = [];
      // add objects to the array
      bundleProductIds.forEach((item, index) => {
        var productQuantity = bundleProductQty[index],
            addToCartQuantity = bundleQuantitySelector * productQuantity;
        dataToPass.push(new productArray(item, addToCartQuantity));
      });
  
      // Pull product ratings and review count to pass to cart object attributes
      var productRatingsName = [],
          productRatingsValue = [],
          productReviewCountName = [],
          productReviewCountValue = [];
      $('.product__rating').each(function(){
        productRatingsName.push( $(this).attr('name'));
        productRatingsValue.push( $(this).val());
      });
      $('.product__review').each(function(){
        productReviewCountName.push( $(this).attr('name'));
        productReviewCountValue.push( $(this).val());
      });
  
      // Object created
      var ratingObj = {},
          reviewObj = {};
  
      // Using loop to insert key
      // value in Object
      for(var i = 0; i < productRatingsName.length; i++){
        ratingObj[productRatingsName[i]] = productRatingsValue[i];
      }
      for(var i = 0; i < productReviewCountName.length; i++){
        reviewObj[productReviewCountName[i]] = productReviewCountValue[i];
      }
  
      var finalAttributes = Object.assign(ratingObj, reviewObj);
  
      //console.log(finalAttributes);
  
  
      //POST IT
      $.ajax({
        type: "POST",
        url: '/cart/add.js',
        dataType: 'jsonp',
        cors: true ,
        data: {
          items: dataToPass,
          attributes: finalAttributes,
        },
  
        //Open the sidecart after success
        complete: function () {
          addToCartOk();
        }
  
      });
    })
  })

    if ($('.bundle-buy-box').length) {
    $window = $(window);
    $window.scroll(function() {
      if (window.matchMedia('(max-width: 767px)').matches) {
        if ( $window.scrollTop() > 0) {
          $("#header").addClass("is-scrolled");
        }
        if ( $window.scrollTop() == 0) {
          $("#header").removeClass("is-scrolled");
        }
      }
      else {
        if ( $window.scrollTop() > 0) {
          $("#header").addClass("is-scrolled");
        }
        if ( $window.scrollTop() == 0) {
          $("#header").removeClass("is-scrolled");
        }
      }
    }); 
  }


  // If bundle contains variant products, show first thumbnail
  $('.bundle-products .bundle-product-form .buy-box__left img.variant-hide:first-of-type').show();

  // Add active class to selected variant if variant options are present for a product
  $('.bundle-products .bundle-product-form select').change(function(){
    $(this).find(':selected').addClass('bundle-price__product')
    .siblings('option').removeClass('bundle-price__product');
  
    //  Find slide to go to based off product selection in buy box
    var thumbnailSlideNumber = $(this).find(':selected').attr('data-slide-target');
  
    $('.product-page-buy-box-slider').slick('slickGoTo',thumbnailSlideNumber);
  
    // recalculate price in price box
    bundlePriceBoxFunction();
  
    var productTitle = $(this).attr('data-product-name');
    var bundleVariantId = $(this).find(':selected').attr('data-variant-id');
    $(this).closest('#product-' + productTitle).find('.variant-hide').hide();
    $('.variant-' + bundleVariantId).show();
  });

  // Single variant product thumbnail to trigger product thumbnail slider
  $('.bundle-product-thumbnail-anchor').on('click',function(){
    var thumbnailSlideNumber = $(this).attr('data-slide-target');
  
    $('.product-page-buy-box-slider').slick('slickGoTo',thumbnailSlideNumber);
  
  });
}

// Determine if the user is a B2B customer
function isB2B() {
  let condition;
  $('.b2b-customer').length != 0 ? condition = true : condition = false;
  return condition;
}

function initBundleBuyBox() {
  // Will check if the buy box was initialized
  bundleBuyBoxListeners();

  // B2B Customer Logic
  if(isB2B()){
    $('.price-container #ComparePrice').hide();
  }
}

initBundleBuyBox();
